import React from "react";
import { motion } from "framer-motion";
import ctavideo from "../assets/cta-video.mp4";

const DesignFuture = () => {
  return (
    <section
      className="bg-white px-4 sm:px-6 lg:px-16 overflow-hidden"
      style={{ fontFamily: "'Poppins', sans-serif" }}
    >
      <div className="relative rounded-none sm:rounded-2xl py-20 overflow-hidden">
        
        {/* Background Video */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={ctavideo} type="video/mp4" />
        </video>

        {/* Dark Overlay */}
        {/* <div
          className="absolute inset-0"
          style={{ background: "rgba(0,0,0,0.45)" }}
        /> */}

        {/* Content */}
        <div className="relative z-10 flex items-center justify-center px-4 sm:px-6 py-8 sm:py-0 min-h-[200px] sm:min-h-0">
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.6 }}
    className="text-center w-full mx-auto"
    style={{
      background: "rgba(255,255,255,0.07)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      border: "1px solid rgba(255,255,255,0.14)",
      borderRadius: "20px",
      padding: "clamp(28px, 5vw, 48px) clamp(20px, 5vw, 56px)",
      maxWidth: "min(560px, 92%)",
      marginLeft: "auto",
      marginRight: "auto",
    }}
  >
    <h2
      className="font-bold text-white mb-4 mx-auto"
      style={{
        fontFamily: "'Space Grotesk', sans-serif",
        fontSize: "clamp(1.1rem, 3.5vw, 1.55rem)",
        lineHeight: 1.25,
        maxWidth: "90%",
      }}
    >
      Let's Design the Future of Your Brand.
    </h2>

    <motion.button
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.95 }}
      onClick={() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
      }}
      className="mx-auto block"
      style={{
        background: "linear-gradient(135deg, #129ADC, #B55DD0, #E154AA, #F45A39)",
        border: "none",
        borderRadius: "100px",
        padding: "10px 32px",
        color: "#fff",
        fontFamily: "'Poppins', sans-serif",
        fontSize: "clamp(12px, 2.5vw, 13px)",
        fontWeight: 600,
        cursor: "pointer",
        letterSpacing: "0.04em",
        minWidth: "min(150px, 70vw)",
        whiteSpace: "nowrap",
      }}
    >
      Work With Me
    </motion.button>
  </motion.div>
</div>
      </div>
    </section>
  );
};

export default DesignFuture;